import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LogoutPage = () => {
	const { logout } = useAuth();
	const baseUrl = process.env.REACT_APP_BASE_URL || '/';

	useEffect(() => {
		// Clear session storage
		sessionStorage.clear();

		// Execute logout
		logout();
	}, [logout]);

	return (
		<div className="container mt-5 text-center">
			<p>You have been logged out.</p>
			<Link to={`${baseUrl}login`} className="btn btn-primary">
				Login
			</Link>
		</div>
	);
};

export default LogoutPage;
